import React from 'react';
import FormInput from '../../Common/formInput';
import { Grid, Button, Box, InputLabel, makeStyles } from '@material-ui/core';
import currentUserSelector from '../../../selectors/currentUserSelector';
import { useDispatch, useSelector } from 'react-redux';
import { updateUserDetailsInSettings } from '../../../actions/get-user-details';
import { requestCurrentUser } from '../../../actions/users';
import Switch from '@material-ui/core/Switch';
import { createAction } from 'redux-actions';
import { ACTIVATE_ADD_BRAND_BUTTON_TOOLTIP } from '../../../constants/actionTypes';

const useStyles = makeStyles({
    inputLabel: {
        color: '#08090a',
        fontSize: '0.875rem',
        fontWeight: '400',
        display: 'inline-flex !important',
        paddingLeft: '10px'
    }
});

export default function GeneralForm() {
    const [formValues, setFormValues] = React.useState({});
    const [editDetails, setEditDetails] = React.useState(false);
    const [error, setError] = React.useState({});
    const currentUser = useSelector(currentUserSelector);
    const dispatch = useDispatch();
    const classes = useStyles();
    const isTooltipActive = useSelector(state => state?.currentUser?.user?.tooltip);
    const activeTooltip = createAction(ACTIVATE_ADD_BRAND_BUTTON_TOOLTIP);

    React.useEffect(() => {
        console.log("General Form", currentUser)
        const { firstName, lastName, email, phone } = currentUser;
        setFormValues({ first_name: firstName, last_name: lastName, email, phone });
        validate('firstName',firstName);
        validate('lastName',lastName);
        validate('phone',phone);
    }, [currentUser]);

    const onChangeHandler = (key, value) => {
        console.log("THE VALUE IN CHANGE HANDLER",key,value)
        setFormValues({ ...formValues, [key]: value })
    }

    const handleSubmit = () => {
        const { first_name, last_name, phone } = formValues;
        const { user } = currentUser;
        if(!error['firstName'] && !error['lastName'] && !error['phone']){
            dispatch(updateUserDetailsInSettings({ first_name, last_name, phone, user_id: user.id })).then(
                data => {
                    dispatch(requestCurrentUser());
                    setEditDetails(false);
                }
            );
        }
    }

    const handleCancel = () => {
        const { firstName, lastName, email, phone } = currentUser;
        setFormValues({ first_name: firstName, last_name: lastName, email, phone });
        setError({});
        setEditDetails(false);
    }

    const validate = (name, value) => {
        console.log("THE VALUE IN VALIDATE FUNCTION",name,value,formValues['first_name'] && formValues['last_name'] && !error['phone'] && !error['firstName'] && !error['lastName'])
        
        switch (name) {
            case 'phone': {
                // let regex = new RegExp(/^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]\d{3}[\s.-]\d{4}$/);
                let regex = new RegExp(/^(\+d{1,2}\s?)?1?\-?\.?\s?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/);
                if(value && value?.trim() !== ""){
                    
             
                let result = regex.test(value);
                if (!result) {
                    setError(error => ({ ...error, phone: `Enter a valid Phone number` }))
                }
                else {
                    let { phone, ...newError } = error;
                    setError(error => ({ ...newError }));
                }
            }
                return;
            }
            case 'firstName': {
                let regex = new RegExp(/^[a-zA-Z ]*$/);
                let result = regex.test(value);
                if (!result) {
                    setError(error => ({ ...error, firstName: `Please enter valid first name` }))
                }
                else {
                    let { firstName, ...newError } = error;
                    setError(error => ({ ...newError }));
                }
                return;
            }
            case 'lastName': {
                let regex = new RegExp(/^[a-zA-Z ]*$/);
                let result = regex.test(value);
                if (!result) {
                    setError(error => ({ ...error, lastName: `Please enter valid last name` }))
                }
                else {
                    let { lastName, ...newError } = error;
                    setError(error => ({ ...newError }));
                }
                return;
            }
        }
    }

    const canSave = formValues['first_name'] && formValues['last_name'] && !error['firstName'] && !error['lastName'] && !error['phone'];
    console.log("THE CANSAVE VALUE",canSave)
    const handleTooltipSwitch = (event) => {
        const { user } = currentUser;
        dispatch(updateUserDetailsInSettings({ tooltip: event.target.checked, user_id: user.id })).then(
            data => {
                dispatch(requestCurrentUser());
                dispatch(activeTooltip())
            }
        );
    }

    return (
        <Grid container>
            <Grid item xs={12} md={6}>
                <FormInput
                    name='first_name'
                    id='first_name'
                    label='First Name*'
                    disabled={!editDetails}
                    value={formValues['first_name'] || ''}
                     onChange={(e) => {onChangeHandler('first_name', e.target.value); validate('firstName', e.target.value);}}
                    helperText={error['firstName']}
                />
            </Grid>
            <Grid item xs={12} md={6}>
                <FormInput
                    name='last_name'
                    id='last_name'
                    label='Last Name*'
                    disabled={!editDetails}
                    value={formValues['last_name'] || ''}
                    onChange={(e) => {onChangeHandler('last_name', e.target.value); validate('lastName', e.target.value);}}
                    helperText={error['lastName']}
                />
            </Grid>
            <Grid item xs={12}>
                <FormInput
                    name='email'
                    id='email'
                    label='Email'
                    disabled
                    value={formValues['email'] || ''}
                    textFieldProps={{ disabled: true }}
                />
            </Grid>
            <Grid item xs={6}>
                <FormInput
                    name='phone'
                    id='phone'
                    disabled={!editDetails}
                    label='Phone Number'
                    value={formValues['phone'] || ''}
                    onChange={(e) => {onChangeHandler('phone', e.target.value, e); validate('phone', e.target.value);}}
                    textFieldProps={{ type: "tel" }}
                    helperText={error['phone']}
                />
            </Grid>
            <Grid item xs={12}>
                <Box display="flex" flexDirection="row" alignItems="center">
                    <InputLabel className={classes.inputLabel}>Tooltip</InputLabel>
                    <Switch checked={isTooltipActive} onClick={handleTooltipSwitch} />
                </Box>
            </Grid>
            <Grid item xs={12}>
                <Box pt={2} display="flex" flexDirection="row-reverse" justifyContent="">
                    {editDetails ?
                        (<>
                            <Button
                                disableRipple
                                disabled={!canSave}
                                variant="contained"
                                color="primary"
                                onClick={handleSubmit}
                                style={{ marginLeft: '0.5rem' }}
                                autoFocus>
                                Save
                            </Button>
                            <Button ml={1} disableRipple variant="contained" onClick={handleCancel} >
                                Cancel
                            </Button></>) : (
                            <Button disableRipple variant="contained" color="primary" onClick={() => setEditDetails(true)} style={{ marginLeft: '0.5rem' }} autoFocus>
                                Edit Details
                            </Button>
                        )}
                </Box>
            </Grid>
        </Grid>
    )
}
